import React from 'react'
import { formatNumbers } from '../Functions/formatNumbers'

const Lieferstelle = (props) => {

	const convertPaymentMethod = (m) => { 
		let method = ''
		switch (m) {
			case 'ec':
				method = 'Girokarte'
				break
			case 'bar':
				method = 'Barzahlung'
				break
			case 'rechnung':
				method = 'Rechnung'
				break
			case 'vorkasse':
				method = 'Vorkasse'
				break
			case 'lastschrift':
				method = 'Lastschrift'
				break
			case 'waermekonto':
				method = 'Wärmekonto'
				break
			case 'garantie':
				method = 'Garantierte Zahlung'
				break
			default:
				method = ''
		}
		return method

	}
	return (
		<div className="no__lieferstelle">

			<strong className="no__blue">Lieferstelle {props.number} (PLZ: {props.plz})</strong>

			<div className="no__flex-row">
				<strong>Liefermenge: </strong>
				<p>
					{formatNumbers(props.liefermenge)} Liter
				</p>
			</div>

			<div className="no__flex-row">
				<strong>Adresse: </strong>
				<p>
					{props.contact.company &&
						<span>{props.contact.company}<br/></span>}
					{props.contact.first} {props.contact.last}<br />
					{props.contact.street} {props.contact.street_number}<br />
					{props.plz} {props.contact.city}<br />
				</p>
			</div>
			{props.contact.email && <div className="no__flex-row">
				<strong>E-Mail: </strong>
				<p>
					{props.contact.email}<br />
				</p>
			</div>}
			<div className="no__flex-row">
				<strong>Zahlung: </strong>
				<p>
					{convertPaymentMethod(props.contact.payment.method)}<br />
				</p>
			</div>
			{props.contact.billing.billing && <div>
				<strong>Abweichende Rechnungs&shy;adresse: </strong>
				<p>
					{props.contact.billing.company && <>{props.contact.billing.company}<br /></>}
					{props.contact.billing.first} { props.contact.billing.last}<br />
					{props.contact.billing.street} { props.contact.billing.street_number}<br />
					{props.contact.billing.plz} { props.contact.billing.city}<br />
					{props.contact.billing.email && <>E-Mail: {props.contact.billing.email}<br /></>}
					{props.contact.billing.phone && <>Telefon: {props.contact.billing.phone}<br /></>}
				</p>
			</div>}
						
		</div>
	)
}

export default Lieferstelle
